import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import {
  normalizeSouthAfricanCellForDisplay,
  normalizeIDNumberForDisplay,
  normalizeSouthAfricanCellnumberToInternational
} from '../utils/normalize'
import { isValidSouthAfricanIDNumber } from 'validator-sa'
import PageHeader from './page-header'
import ValidationError from './validation-error'
import Loader from './loader'

const normalizeTel = v => v && v.match(/^0/) ? normalizeSouthAfricanCellForDisplay(v) : v

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => {

  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        className='form-control'
        {...input}
        placeholder={label}
        type={type}
        autoFocus={input.name === 'sub'}
      />
      {touched && ((error && <ValidationError error={error} type={"error"}/>) || (warning && <ValidationError error={warning} type={"warning"}/>))}
    </div>
  )
}

let Login = ({
  user,
  redirect_uri,
  loading,
  handleSubmit,
  pristine,
  invalid,
  submitting,
  login,
  errorMessage
}) => {

  return (
    <div>
      <PageHeader title={"Sign in with your DA Account"}/>
      <div className='container'>
        {(errorMessage == null) && (
          <div className='alert alert-info'>
            <p>
              Welcome to the DA&apos;s login system. Please enter your ID number
              and the cellphone number that you registered with us, so you can
              receive a one-time PIN to log in.
            </p>
  
            <p>
              If this is your first time logging in at the DA, please enter your
              ID number and cellphone number, and a new account will be
              registered for you.
            </p>
          </div>
        )}
        <form>
          <div className='form-group'>
            <Field
              normalize={normalizeIDNumberForDisplay}
              label='ID Number'
              name="sub"
              type='tel'
              component={renderField}
            />
          </div>
          <div className='form-group'>
            <Field
              normalize={normalizeTel}
              label='Cell Number'
              name="cellnumber"
              type='tel'
              component={renderField}
            />
          </div>
          <button
            onClick={handleSubmit(values => {
              login(values, redirect_uri)
            })}
            disabled={loading || pristine || submitting || invalid}
            className="btn btn-success btn-block">
              { (loading || submitting) ? <Loader/> : 'Sign In' }
          </button>
        </form>
      </div>
    </div>
  )
}

const validate = values => {
  const errors = {}
  if(!values.sub) {
    errors.sub = 'Your South African Identity Number is required'
  }

  if(!values.cellnumber) {
    errors.cellnumber = 'Cell Number is required'
  } else {
    const invalidText = 'Cell number must be 10 digits long, or an international number starting with "+"'
    if (values.cellnumber.match(/^0/)) { // local (SA) number
      if(values.cellnumber.replace(/\(|\)/g, "").replace(/\D/g, '').length !== 10) {
        errors.cellnumber = invalidText
      }
    } else { // empty or international (non-SA) number
      if (values.cellnumber.match(/^\+/)) {
        if (values.cellnumber.length < 7) {
          errors.cellnumber = 'Please enter your full international cell number'
        }
      } else {
        errors.cellnumber = invalidText
      }
    }
  }

  if(values.sub && values.sub.replace(/\D/g, '').length !== 13) {
    errors.sub = 'ID number must be 13 digits long'
  } else if (values.sub && !isValidSouthAfricanIDNumber(values.sub)) {
    errors.sub = 'Not a valid South African ID number'
  }
  return errors
}

Login = reduxForm({
  form: 'login',
  validate
})(Login)

function mapStateToProps({user,loading,clientFullyInitialised,error}, ownProps) {
  const { redirect_uri } = ownProps.location.query
  return {
    user: user,
    loading: loading,
    redirect_uri,
    initialising: !clientFullyInitialised,
    errorMessage: error.err,
    ...ownProps
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    login: bindActionCreators(actions.login, dispatch)
  })
}

Login = connect(mapStateToProps, mapDispatchToProps)(Login)

// TODO: keep in its own file
class HideUntilMounted extends React.Component {
  state = {
    visible: false
  }
  componentDidMount() {
    this.setState({ visible: true })
  }
  render() {
    if (!this.state.visible) {
      return <Loader />
    }
    return this.props.children
  }
}

export default props => <HideUntilMounted><Login {...props}/></HideUntilMounted>



// WEBPACK FOOTER //
// ./src/app/components/login.js